<template>
  <div>
    <div>
      <el-card class="btn-card">
        <div class="btn-box">
          <el-upload
            class="upload-demo"
            action="/dealer/equipment/importEquipment"
            multiple
            :on-success="handleAvatarSuccess"
          >
            <el-button type="primary"
              >Upload your list of devices on installment</el-button
            >
          </el-upload>
          <div>
            <el-button type="primary" @click="add"
              >Add New Installments</el-button
            >
          </div>
        </div>
        <p class="download">
          <img src="@/assets/images/pc/download.png" alt="" />
          <el-button @click="download" type="text"
            >Download the list template</el-button
          >
        </p>
      </el-card>
      <div class="table-box">
        <el-table
          v-loading="loading"
          :data="tableData"
          :header-cell-style="{ 'text-align': 'center', color: '#000000' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
        >
          <el-table-column
            prop="devicesn"
            label="Device SN"
            fixed="left"
            width="120px;"
          >
          </el-table-column>
          <el-table-column
            prop="productseries"
            label="Product Series"
            fixed="left"
            width="120px;"
          >
          </el-table-column>
          <el-table-column
            prop="registrationDate"
            label="Regist Date"
            fixed="left"
          >
          </el-table-column>
          <el-table-column label="Payment Due Date">
            <el-table-column
              :prop="'date' + index"
              :label="index + 1 + ''"
              :key="index"
              v-for="(item, index) in dateList"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column prop="address" label="Status" fixed="left">
            <template slot-scope="scope">
              <span>{{ statusArr[scope.row.statas] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Application" fixed="left">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.statas == 0"
                type="primary"
                size="small"
                @click="lock(scope.row, 'lock')"
                >Lock</el-button
              >
              <el-button
                v-if="scope.row.statas == 1"
                size="mini"
                @click="lock(scope.row, 'unlock')"
                >Unlock</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="Edit" fixed="left" width="160px">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="editList(scope.row)"
                style="margin: 5px"
                >Edit</el-button
              >
              <el-popconfirm
                title="Are you sure to delete?"
                placement="top"
                confirm-button-text="yes"
                cancel-button-text="no"
                @confirm="deleteList(scope.row)"
              >
                <el-button slot="reference" size="mini">Delete</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.current"
          :page-size="pagination.pageSize"
          layout="total,sizes,prev, pager, next"
          :page-sizes="[10, 20, 30, 40, 50]"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="Please input installment info"
      :visible.sync="dialogFormVisible"
      width="600px"
    >
      <div class="pop-box-pc">
        <el-form>
          <el-form-item label="Device SN" :label-width="formLabelWidth">
            <el-input
              v-model="formData.devicesn"
              autocomplete="off"
              :disabled="formData.show"
              placeholder="Device SN"
            ></el-input>
          </el-form-item>
          <el-form-item label="Payment Due Date" :label-width="formLabelWidth">
            <div class="scroll-box">
              <div
                v-for="(item, index) in paymentdateList"
                :key="item.id"
                style="margin-bottom: 5px"
                class="date-box"
              >
                <span class="date-index">{{ index + 1 }}</span>
                <el-date-picker
                  v-model="item.paymentdate"
                  type="date"
                  format="dd-MM-yyyy"
                  value-format="yyyy/MM/dd"
                  placeholder="Select date"
                  :picker-options="pickerOptions"
                  @change="changeTime"
                  @focus="focusTime(index)"
                  :clearable="false"
                  :editable="false"
                >
                </el-date-picker>
                <img
                  @click="reduceDate(item.id)"
                  v-if="item.id !== 1"
                  src="@/assets/images/mobile/jian.png"
                  alt=""
                />
              </div>
              <img
                class="addImg"
                @click="addDate"
                src="@/assets/images/mobile/add.png"
                alt=""
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: right;position: relative;">
        <div class="line"></div>
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submit" :loading="submitLoading"
          >Confirm</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEquipmentList,
  exportEquipment,
  applyLock,
  applyUnLock,
  addDistributorEquipment,
  modifyDistributorEquipment,
  deleteDistributorEquipment
} from '@/api/equipment.js'

export default {
  data () {
    return {
      tableData: [],
      statusArr: [
        'Good',
        'Locked',
        'LockingProcess',
        'UnLockingProcess',
        'Wrong SN',
        'Error，Please Fill In Blanks On Installments',
        'Error. Duplicate SN'
      ],
      // 分页
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0
      },
      loading: false,
      dateList: [],
      // 弹框数据
      dialogFormVisible: false,
      submitType: '',
      submitLoading: false,
      formLabelWidth: '200px',
      // 添加提交数据
      formData: {
        devicesn: '',
        paymentdate: ''
      },
      paymentdateList: [
        {
          id: 1,
          paymentdate: ''
        }
      ],
      // 时间范围
      pickerOptions: ''
    }
  },
  mounted () {
    this.getEquipmentList()
    console.log(1)
    const clearFlag = JSON.parse(sessionStorage.getItem('clearFlag'))
    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      () => {
        console.log(clearFlag, 2)
        if (document.body.clientWidth < 650) {
          console.log(clearFlag, 3)
          if (!clearFlag) {
            console.log(clearFlag, 4)
            sessionStorage.setItem('clearFlag', JSON.stringify(true))
            console.log(clearFlag, 5)
            sessionStorage.setItem('mobileFlag', JSON.stringify(false))
            console.log(clearFlag, 6)
            window.location.reload()
            console.log(clearFlag, 7)
          }
        }
      }
    )
  },
  methods: {
    focusTime (index) {
      // 选择框不等于第一个和最后一个
      if (index && index !== this.paymentdateList.length - 1) {
        const min = this.paymentdateList[index - 1].paymentdate
        const max = this.paymentdateList[index + 1].paymentdate
        this.pickerOptions = {
          disabledDate (v) {
            return (
              v.getTime() <= new Date(min).getTime() ||
              v.getTime() >= new Date(max).getTime()
            )
          }
        }
      } else {
        if (this.paymentdateList.length === 1) {
          this.pickerOptions = {
            disabledDate (v) {
              return v.getTime() < 0
            }
          }
          return
        }
        if (!index) {
          const min = this.paymentdateList[index - 1]
            ? this.paymentdateList[index - 1].paymentdate
            : '1970/01/01'
          const max = this.paymentdateList[index + 1].paymentdate
          this.pickerOptions = {
            disabledDate (v) {
              return (
                v.getTime() <= new Date(min).getTime() ||
                v.getTime() >= new Date(max).getTime()
              )
            }
          }
        } else {
          const value = this.paymentdateList[index - 1].paymentdate
          this.pickerOptions = {
            disabledDate (v) {
              return v.getTime() <= new Date(value).getTime()
            }
          }
        }
      }
    },
    // 禁止选择已选时间以前的时间
    changeTime (value) {
      // this.pickerOptions = {
      //   disabledDate (v) {
      //     return v.getTime() <= new Date(value).getTime()
      //   }
      // }
    },
    // 编辑
    editList (item) {
      this.submitType = 'edit'
      this.dialogFormVisible = true
      this.formData.devicesn = item.devicesn
      this.formData.id = item.id
      this.formData.show = item.statas && item.statas !== '4'
      const arr = item.paymentdate.split(',')
      this.paymentdateList = []
      arr.forEach((value, i) => {
        this.paymentdateList.push({
          id: i + 1,
          paymentdate: value
        })
      })
    },
    // 删除
    deleteList (item) {
      const params = {
        id: item.id,
        deviceSn: item.devicesn
      }
      deleteDistributorEquipment(params).then((res) => {
        this.$message.success('success')
        this.getEquipmentList()
      })
    },
    // 弹框确定
    submit () {
      if (!this.formData.devicesn) {
        this.$message({
          message: 'Please fill in the Device SN',
          type: 'error'
        })
        return false
      }
      this.formData.paymentdate = []
      const flag = this.paymentdateList.some((item) => {
        if (!item.paymentdate) {
          this.$message({
            message: 'Please fill in the date',
            type: 'error'
          })
          return true
        }
        this.formData.paymentdate.push(item.paymentdate)
      })
      if (flag) return
      this.formData.paymentdate = this.formData.paymentdate.join(',')
      this.submitLoading = true
      if (this.submitType === 'add') {
        // 添加
        addDistributorEquipment(this.formData)
          .then((res) => {
            this.$message.success('success')
            this.getEquipmentList()
            this.dialogFormVisible = false
          })
          .finally(() => {
            this.submitLoading = false
          })
      } else {
        // 编辑
        modifyDistributorEquipment(this.formData)
          .then((res) => {
            this.$message.success('success')
            this.getEquipmentList()
            this.dialogFormVisible = false
          })
          .finally(() => {
            this.submitLoading = false
          })
      }
    },
    // 减少时间
    reduceDate (id) {
      this.paymentdateList = this.paymentdateList.filter((item) => {
        return item.id !== id
      })
    },
    // 添加时间
    addDate () {
      const flag = this.paymentdateList.some((item) => {
        if (!item.paymentdate) {
          return true
        }
      })
      if (flag) {
        this.$message.error('Please fill in the date')
        return
      }
      const id = new Date().getTime()
      this.paymentdateList.push({
        id,
        paymentdate: ''
      })
    },
    // 添加弹框
    add () {
      this.dataReset()
      this.dialogFormVisible = true
      this.submitType = 'add'
    },
    // 重置数据
    dataReset () {
      this.formData = {
        devicesn: '',
        paymentdate: ''
      }
      this.paymentdateList = [
        {
          id: 1,
          paymentdate: ''
        }
      ]
      this.pickerOptions = {
        disabledDate (v) {
          return v.getTime() < 0
        }
      }
    },
    handleAvatarSuccess (res, file) {
      if (res.code === 'S0000') {
        this.$message.success('success')
        this.getEquipmentList()
      } else {
        this.$message.error(res.desc || res.msg)
      }
    },
    // 获取列表
    getEquipmentList () {
      this.loading = true
      const data = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      getEquipmentList(data)
        .then((res) => {
          let maxlength = 0
          res.data.list.forEach((item) => {
            if (item.registrationDate) {
              item.registrationDate = item.registrationDate.split(' ')[0]
              item.registrationDate = item.registrationDate
                .split('-')
                .reverse()
                .join('-')
            }
            if (item.paymentdate) {
              const arr = item.paymentdate.split(',')
              if (arr.length > maxlength) {
                this.dateList = arr
                maxlength = arr.length
              }
              arr.forEach((value, i) => {
                const key = 'date' + i
                item[key] = value.split('/').reverse().join('/')
              })
            }
          })
          this.tableData = res.data.list
          this.pagination.total = res.data.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 导出模板
    download () {
      exportEquipment()
        .then((res) => {})
        .catch((res) => {
          console.log('response: ', res.data)
          const url = window.URL.createObjectURL(new Blob([res.data]))
          // 生成一个a标签
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          // 生成时间戳
          // const timestamp = new Date().getTime()
          link.download = 'Template of Installment Info.xlsx'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
    },
    // 锁机
    lock (data, type) {
      this.$confirm('Do you want to do this?', '', {
        confirmButtonText: 'Comfirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
        customClass: 'pc-message'
      })
        .then(() => {
          this.apply(data, type)
        })
        .catch(() => {})
    },
    // 解锁
    apply (data, type) {
      const params = {
        id: data.id,
        deviceSn: data.devicesn
      }
      if (type === 'lock') {
        applyLock(params).then((res) => {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.getEquipmentList()
        })
      } else {
        applyUnLock(params).then((res) => {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.getEquipmentList()
        })
      }
    },
    // 每页数量
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.getEquipmentList()
    },
    // 分页
    handleCurrentChange (val) {
      this.pagination.current = val
      this.getEquipmentList()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 1282px;
  margin: 0 auto;
  margin-top: 20px;
  text-align: right;
}
.table-box {
  width: 1282px;
  margin: 0 auto;
}
.btn-card {
  width: 1282px;
  margin: 0 auto;
  margin-bottom: 20px;
  .btn-box {
    display: flex;
    div {
      margin-right: 30px;
    }
  }
  .download {
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
}
.el-button--text:hover {
  text-decoration: underline;
}
::v-deep .el-dialog__header {
  background: linear-gradient(0deg, #e7e7e7 0%, #ffffff 100%);
  [class*=" el-icon-"] {
    font-size: 20px;
    font-weight: 700;
  }
}
::v-deep .el-dialog__body {
  padding: 10px 20px;
}
::v-deep .el-table .cell {
  padding: 0;
}
.el-input--prefix .el-input__inner {
  width: 492px;
  height: 32px;
}
.el-date-editor.el-input {
  width: 492px;
}
.el-input--prefix .el-input__inner {
  width: 492px;
  height: 32px;
}
.scroll-box{
  // max-height: 380px;
  // overflow-y: auto;
}
.date-box {
  display: flex;
  align-items: center;
  img {
    width: 32px;
    height: 32px;
    cursor: pointer;
    margin-left: 10px;
  }
}
.addImg {
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin-left: 24px;
  margin-top: 10px;
}
.line{
  position: absolute;
  top: -13px;
  left: -20px;
  width: 600px;
  border-top: 1px solid #D8D8D8;
}
::v-deep .el-input__prefix{
  // right: -430px;
}
</style>

<style lang="scss">
.pc-message{
  width: 420px;
}
.pop-box-pc {
  .red-satr {
    color: red;
  }
  .el-form-item__label {
    float: none;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
  .date-index {
    display: inline-block;
    width: 20px;
    margin-right: 5px;
  }
}
.el-popconfirm {
  background: #fff;
  min-width: 150px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  padding: 12px;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
}
</style>
